<template>
  <vue-multiselect class="content-blocks-dropdown dropdown"
                   open-direction="bottom"
                   :placeholder="i18n.t('components.trix_editor.toolbar.insertContent')"
                   :options="contentBlocks"
                   :show-labels="false"
                   @update:model-value="onClick">
    <template #option="props">
      {{ props.option.label }}
    </template>
  </vue-multiselect>
</template>

<script>
import VueMultiselect from 'vue-multiselect'

export default {
  components: { VueMultiselect },

  props: {
    contentBlocks: {
      type: Array,
      required: true
    }
  },

  emits: ['insert'],

  methods: {
    onClick(contentBlock) {
      this.$emit('insert', contentBlock)
    }
  }
}
</script>


<style lang="scss" scoped>
 @use "~friendship_styles/colors" as colors;

  .content-blocks-dropdown {
    width: 200px;
  }

  // Overriding the height of the component requires changing a bunch of CSS.
  // See: https://github.com/shentao/vue-multiselect/issues/143

  $custom-height: 27px;

  ::v-deep(.multiselect) {
    height: $custom-height;
    min-height: unset;
  }

  ::v-deep(.multiselect__placeholder) {
    margin: 0 5px;
  }

  ::v-deep(.multiselect__tags) {
    border: none;
    border-radius: 0;
    min-height: unset;
    height:  $custom-height;
    font-size: 11px;
    padding: 0 2px;
    display: flex;
    align-items: center;

    input {
      font-size: 11px;
      height: $custom-height;
      margin-bottom: 0;
      padding: 0 5px;
    }
  }

  ::v-deep(.multiselect__select) {
    height: $custom-height;
    margin-top: auto;
    margin-bottom: auto;
  }

  ::v-deep(.multiselect__option) {
    font-size: 11px;
  }

  // Override highlight color for the selected option
  ::v-deep(.multiselect__option--highlight) {
    background: colors.$dark-blue;
  }
</style>
